/**
 * DescriptionTip — the ⓘ after an option's name in a checkbox list, opening its
 * description (att_event_types.event_type_description: up to 1000 characters, too long
 * to show inline). Renders nothing when the description is empty or blank, so a list can
 * pass every row's value without checking.
 *
 * Used by FilterSubSection (descriptionKey: the report Event Types filters) and the
 * High Priority tab on Cloud System Settings. An InfoPopover, so it opens on hover with
 * no delay, pins on a click or tap (tablets), and closes on Escape or a scroll.
 *
 * Built to sit inside the row's <label>: a click on it would otherwise also toggle the
 * row's checkbox. preventDefault stops the label's activation; InfoPopover's own click
 * (pin) has already run by the time the event bubbles up to the wrapper.
 *
 * @param {string} name        — the option's name: the popover heading and the ⓘ's label
 * @param {string} [description]
 */

import InfoPopover from './InfoPopover.jsx';
import './description-tip.css';

const stopLabelToggle = (e) => e.preventDefault();

/* The popover opens upward when less room than this is left below the row. A full
   1000-character description is about 285px tall at 360px wide, so the threshold follows
   the text's rough height (~50 characters a line) instead of the hook's 120px default,
   which suits a one-line tip and let a long one run off the bottom of the screen. */
const TIP_WIDTH = 360;
const tipHeight = (text) => Math.min(340, 48 + (Math.ceil(text.length / 50) + (text.match(/\n/g) || []).length) * 18);

const DescriptionTip = ({ name, description }) => {
    const text = String(description ?? '').trim();
    if (!text) return null;
    return (
        <span className="description-tip" onClick={stopLabelToggle}>
            <InfoPopover
                heading={name}
                body={text}
                label={`About ${name}`}
                maxWidth={TIP_WIDTH}
                flipBelow={tipHeight(text)}
                className="description-tip__popover"
            />
        </span>
    );
};

export default DescriptionTip;
